import React from 'react';
import { Box, Typography, Button } from '@mui/material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('AR Experience Error:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box 
          display="flex" 
          flexDirection="column" 
          justifyContent="center" 
          alignItems="center" 
          height="100vh"
          gap={2}
          p={3}
        >
          <Typography variant="h5" color="error" gutterBottom>
            Something went wrong with the menu viewer
          </Typography>
          <Typography variant="body1" textAlign="center" color="text.secondary">
            {this.state.error?.message || 'An unexpected error occurred'}
          </Typography>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={this.handleRetry}
            sx={{ mt: 2 }}
          >
            Retry Loading Menu
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;